import React, { useEffect, useRef, useState } from 'react'

import { IconComponent } from '@octane/spark'
import { DropdownWrapper } from 'containers/Navbar/LoggedInUser/LoggedInUser.styled'
import { useBrandConfig } from 'contexts/BrandConfigContextProvider'

import { DropdownCustomItem } from './DropdownCustomItem/DropdownCustomItem'
import { DropdownUrlItem } from './DropdownUrlItem/DropdownUrlItem'
import { NavbarDropdownContent } from './NavbarDropdown.styled'
import NavbarDropdownButton from './NavbarDropdownButton/NavbarDropdownButton'

export interface NavbarDropdownProps {
    id: string
    text: string
    icon: IconComponent
    children: React.ReactNode
}

export default function NavbarDropdown({
    id,
    icon,
    text,
    children,
}: Readonly<NavbarDropdownProps>): JSX.Element {
    const [toggleDropdown, setToggleDropdown] = useState(false)
    const node = useRef<HTMLLIElement>(null)
    const { navbarForceWhite } = useBrandConfig()

    const clickOutside = (event: MouseEvent) => {
        if (node?.current?.contains(event.target as Node)) {
            return
        }

        setToggleDropdown(false)
    }

    useEffect(() => {
        document.addEventListener('click', clickOutside)

        return () => {
            document.removeEventListener('click', clickOutside)
        }
    }, [])

    return (
        <DropdownWrapper as="li" ref={node} style={{ position: 'relative' }}>
            <NavbarDropdownButton
                id={id}
                icon={icon}
                text={text}
                isNavbarWhite={navbarForceWhite}
                onClick={() => setToggleDropdown(!toggleDropdown)}
            />
            {toggleDropdown && (
                <NavbarDropdownContent>{children}</NavbarDropdownContent>
            )}
        </DropdownWrapper>
    )
}

NavbarDropdown.UrlItem = DropdownUrlItem
NavbarDropdown.CustomItem = DropdownCustomItem
